$(document).ready(function() {
  setTimeout(function () {
    $(".sku-wrap-selection>div:first-child").addClass("active");
    $("#min-cart-recommendation .product-grid .grid__item").each(function () {
      var stringVariant = "";
      var selectedVaraint = "";
      $(this).find(".wrap-sku-selection .sku-wrap-selection>div").each(function () {
        if ($(this).hasClass("active")) {
          let skuValue = " + " + $(this).attr("skuvalue");
          stringVariant += skuValue;
        }
      });
      let resultVariant = $.trim(stringVariant.replace(" + ", ""));
  
      $(this).find(".nosto-sku-select select option").each(function () {
        if (resultVariant == $.trim($(this).text())) {
          selectedVaraint = $(this).val();
        }
      });
      
      if ($(this).find(".nosto-sku-select select option.active")) {
        $(this).find(".nosto-sku-select select").val($(this).find(".nosto-sku-select select option.active").val()).trigger("change");
      }
      $(this).find(".nosto-sku-select select").val(selectedVaraint).trigger("change");
    });
  
    $(".sku-wrap-selection>div").click(function(){
      $(this).parent().find('div').removeClass('active')
      $(this).addClass('active')
      var stringVariant = "";
      var selectedVaraint = "";
      $(this).parents('.card__information').find(".wrap-sku-selection .sku-wrap-selection>div").each(function () {
        if ($(this).hasClass("active")) {
          let skuValue = " + " + $(this).attr("skuvalue");
          stringVariant += skuValue;
        }
      });
      let resultVariant = $.trim(stringVariant.replace(" + ", ""));
  
      $(this).parents('.card__information').find(".nosto-sku-select select option").each(function () {
        if (resultVariant == $.trim($(this).text())) {
          selectedVaraint = $(this).val();
        }
      });    
      $(this).parents('.card__information').find(".nosto-sku-select select").val(selectedVaraint).trigger("change");
      
    });
  
    $(".btn-sku-cart button").click(function(){
      $("drawer-footer").trigger('click')
    })
    
  }, 4000);
  
  $(".popup-with-zoom-anim").magnificPopup({
    type: "inline",
    fixedContentPos: false,
    fixedBgPos: true,
    overflowY: "auto",
    closeBtnInside: true,
    preloader: false,
    midClick: true,
    removalDelay: 300,
    mainClass: "my-mfp-zoom-in",
  });

  $(".accordion summary").click(function () {
    if ($(this).parent().attr("open")) {
      $(".accordion__content").hide();
    } else {
      $(".accordion__content").hide();
      $(this).parent().toggleClass("open");
      $(this).parent().find(".accordion__content").slideToggle();
    }
  });

  $(".product__accordion summary").click(function () {
    if ($(this).parent().attr("open")) {
      $(".product__accordion details").removeClass("open");
      $(".accordion__content").hide();
    } else {
      $(".product__accordion details").removeClass("open");
      $(".accordion__content").hide();
      $(this).parent().toggleClass("open");
      $(this).parent().find(".accordion__content").slideToggle();
    }
  });
  
  $(".country_switcher").change(function(){
    window.location.href = $(this).val()
  });

  if ($(window).width() < 750) {
    $(".footer-block__heading").click(function () {
      $(this).parent().toggleClass("open");
      $(this).parent().find("ul").slideToggle();
    });
  }

  $("#personal-note").change(function () {
    $("#cart-errors").hide();
    if ($(this).is(":checked")) {
      $(this).parent().find(".cart__note").show();
    } else {
      $(this).parent().find(".cart__note").hide();
    }
  });
  $("#gift-wrapping").change(function () {
    $("#cart-errors").hide();
    $("#gift-bag").prop("checked", false);
  });
  $("#gift-bag").change(function () {
    $("#cart-errors").hide();
    $("#gift-wrapping").prop("checked", false);
  });

  $("body").on("click", '[name="checkout"]', function () {
    if ($("#gift-wrapping").is(":checked")) {
      var id = $("#gift-wrapping").val();
      jQuery.post(window.Shopify.routes.root + "cart/add.js", {
        items: [{ id: id, quantity: 1 }],
      });
    } else if ($("#gift-bag").is(":checked")) {
      var id = $("#gift-bag").val();
      jQuery.post(window.Shopify.routes.root + "cart/add.js", {
        items: [{ id: id, quantity: 1 }],
      });
    }
    setTimeout(function () {
      $(this).submit();
    }, 1000);
  });
  
  $(".card__color-list-item").hover(
    function () {
      var value = $(this).data("value");
      $(this).parents(".card-wrapper").find(".card__media .card__media-option").hide();
      $(this)
        .parents(".card-wrapper")
        .find(".card__media .card__media-option#media-" + value)
        .show();
    },
    function () {
      $(this).parents(".card-wrapper").find(".card__media .card__media-option").hide();
    }
  );
});

function selectOneChange() {
  var mainVariant = $("#main-variant").text();
  var optionOneValue = $(".product-form__option1 input:checked").val();
  var optionTwoValue = $(".product-form__option2 input:checked").val();
  var optionThreeValue = $(".product-form__option3 input:checked").val();    
  
  if (optionThreeValue) {
    var optionOneTwoThree = "anh" + " / " + $.trim(optionOneValue) + " / " + $.trim($(".product-form__option2 input:checked").val()) + " / " + $.trim($(".product-form__option3 input:checked").val()) + " / anh";
    
    $(".product-form__option2 .cls-op-values div").each(function () {
      let resultTwo = "anh" + " / " + $.trim(optionOneValue) + " / " + $(this).find('input').val() + " / " + $.trim($(".product-form__option3 input:checked").val()) + " / anh";
      $(this).toggleClass('hide', !mainVariant.includes(resultTwo));
    });

    $(".product-form__option3 .cls-op-values div").each(function () {
      let resultThree = "anh" + " / " + $.trim(optionOneValue) + " / " + $.trim($(".product-form__option2 input:checked").val()) + " / " + $(this).find('input').val() + " / anh";
      $(this).toggleClass('hide', !mainVariant.includes(resultThree));
    });

    if(!mainVariant.includes(optionOneTwoThree)) {
      var divList = $('.product-form__option2 .cls-op-values div');
      divList.each(function(index, element) {
        if (!$(element).hasClass('hide')) {
          $(element).find('label').click();
          $(".product-form__option1 input:checked").parent().find('label').click();
          return false;
        }
      });
    }

  } else {
    if (optionTwoValue) {
      var optionOneTwo = "anh" + " / " + $.trim(optionOneValue) + " / " + $.trim($(".product-form__option2 input:checked").val()) + " / anh";
      $(".product-form__option2 .cls-op-values div").each(function () {
        let resultTwo = "anh" + " / " + $.trim(optionOneValue) + " / " + $(this).find('input').val() + " / anh";
        $(this).toggleClass('hide', !mainVariant.includes(resultTwo));
      });     
      
      if(!mainVariant.includes(optionOneTwo)) {
        var divList = $('.product-form__option2 .cls-op-values div');
        divList.each(function(index, element) {
          if (!$(element).hasClass('hide')) {
            $(element).find('label').click();
            $(".product-form__option1 input:checked").parent().find('label').click();
            return false;
          }
        });
      }      
    }
  }
}

function selectTwoChange() {
  var mainVariant = $("#main-variant").text();
  var optionOneValue = $(".product-form__option1 input:checked").val();
  var optionThreeValue = $(".product-form__option3 input:checked").val();    
  
  if (optionThreeValue) {
    var optionOneTwoThree = "anh" + " / " + $.trim(optionOneValue) + " / " + $.trim($(".product-form__option2 input:checked").val()) + " / " + $.trim($(".product-form__option3 input:checked").val()) + " / anh";

    $(".product-form__option3 .cls-op-values div").each(function () {
      let resultThree = "anh" + " / " + $.trim(optionOneValue) + " / " + $.trim($(".product-form__option2 input:checked").val()) + " / " + $(this).find('input').val() + " / anh";
      $(this).toggleClass('hide', !mainVariant.includes(resultThree));
    });

    if(!mainVariant.includes(optionOneTwoThree)) {
      var divList = $('.product-form__option3 .cls-op-values div');
      divList.each(function(index, element) {
        if (!$(element).hasClass('hide')) {
          $(element).find('label').click();
          $(".product-form__option2 input:checked").parent().find('label').click();
          return false;
        }
      });
    }

  } else {
    
  }
}

function setBackgroundVairant() {
  let dataOption = $(".product-form__option1 input:checked").parent().find('label').attr("data-option");
  if (dataOption == 'farve' || dataOption == 'color' || dataOption == 'material' || dataOption == 'materiale') {
    let variantImageData = $(".variant-image-data").text().split(" ; ");
    let dataValue = $(".product-form__option1 input:checked").val();

    $.each(variantImageData, function(index, value) {
      $(".product-form__option2 .cls-op-values div").each(function () {
        let resultTwo = dataValue + " / " + $(this).find('input').val();
        if (value.includes(resultTwo) && value.includes('files')  && $(this).find('label').attr('data-option')) {
          $(this).find('label').css("background-image", "url('" + value.split(" | ")[1] + "')");
        }
      }); 
    });      

  }  
}

$(document).ready(function () {
  
  setTimeout(function () { selectOneChange(); setBackgroundVairant();}, 100);
  
  $(".product-form__option1 label").click(function(){
    setTimeout(function () { selectOneChange(); }, 100);
    
    if ($(this).attr('data-option') == 'farg' || $(this).attr('data-option') == 'farbe' || $(this).attr('data-option') == 'farve' || $(this).attr('data-option') == 'color' || $(this).attr('data-option') == 'material' || $(this).attr('data-option') == 'materiale') {
      let variantImageData = $(".variant-image-data").text().split(" ; ");
      let dataValue = $(this).parent().find('input').val();

      $.each(variantImageData, function(index, value) {
        $(".product-form__option2 .cls-op-values div").each(function () {
          let resultTwo = dataValue + " / " + $(this).find('input').val();
          if (value.includes(resultTwo) && value.includes('files') && $(this).find('label').attr('data-option')) {
            $(this).find('label').css("background-image", "url('" + value.split(" | ")[1] + "')");
          }
        }); 
      });      

    }
  });

  $(".product-form__option2 label").click(function(){
    setTimeout(function () { selectTwoChange(); }, 100);
  }); 

  $(".product-form__option3 label").click(function(){
    $(".product-form__option1 input:checked").parent().find('label').click();
  });   
  
  $("#product-quantity-select").change(function () {
    if ($(this).val() == "10") {
      $(".form-field--qty-select").addClass("hidden");
      $(".form-field--qty-input").removeClass("hidden");
      $(".form-field--qty-input").addClass("visible");
    }
    $("#product-quantity-input").val($(this).val());
  });
  
});

$(document).ready(function(){
  $(".product-form__option1 .cls-op-values div").each(function(){
    if($(this).find('input').is(':checked')){
      $(this).find('input').prop('checked', false); 
      $(this).find('input').click();
    }
  })
  $('.card-item-variant').hover(function(){
    var _this = $(this);
    var id = $(this).attr('data-id');
    var dataTitle = '';
    $('.card__size-list-item').show();

    var imgSrc = $(this).find('img').attr('data-src');
    if (imgSrc){
      $(this).parents('.card--media').find('.motion-reduce-second').attr('srcset', imgSrc)
    }
    
    $(this).parent().parent().find('.variant-options select option').each(function(){
      if($(this).val() == id) {
        dataTitle = $(this).attr('data-title');
      }
    });

    var splitTitle = dataTitle.split(" / ");
    
    if ($(this).parent().parent().find('.card__color-list-2').html()) {
      
      var compateTitle = $.trim(splitTitle[0]) + " / " + $.trim(splitTitle[1]);
      _this.parent().parent().find('.card__size-list .card__size-list-item').each(function(){
        __this = $(this);
        var check = 'false';
        var sizeTitle = $.trim(splitTitle[0]) + " / " + $.trim(splitTitle[1]) + " / " + $.trim($(this).text());
        _this.parent().parent().find('.variant-options select option').each(function(){
          if($(this).attr('data-title').includes(sizeTitle)) {
           check = 'true';
          }     
        });
        if (check == 'false') {
          _this.parent().parent().find('.size-list-'+$.trim($(this).text()).toLowerCase()).hide();
        }
      })
  
      $(this).parent().parent().find('.variant-options select option').each(function(){
        if($(this).attr('data-title').includes(compateTitle)) {
          if ($(this).attr('avai') == 'false') {
            var clsSize = $(this).attr('data-title').split(" / ");
            _this.parent().parent().find('.size-list-'+clsSize[2].toLowerCase()).hide();
          }          
        }      
      });
    } else {

      var compateTitle = $.trim(splitTitle[0]);
      _this.parent().parent().find('.card__size-list .card__size-list-item').each(function(){
        __this = $(this);
        var check = 'false';
        var sizeTitle = $.trim(splitTitle[0]) + " / " + $.trim($(this).text());
        _this.parent().parent().find('.variant-options select option').each(function(){
          if($(this).attr('data-title').includes(sizeTitle)) {
           check = 'true';
          }     
        });
        if (check == 'false') {
          _this.parent().parent().find('.size-list-'+$.trim($(this).text()).toLowerCase()).hide();
        }
      })
  
      $(this).parent().parent().find('.variant-options select option').each(function(){
        if($(this).attr('data-title').includes(compateTitle)) {
          if ($(this).attr('avai') == 'false') {
            var clsSize = $(this).attr('data-title').split(" / ");
            _this.parent().parent().find('.size-list-'+clsSize[1].toLowerCase()).hide();
          }          
        }      
      });      
    }
    
  });
});